import { render } from "./Policies.vue?vue&type=template&id=49bdde53&scoped=true"
import script from "./Policies.vue?vue&type=script&lang=js"
export * from "./Policies.vue?vue&type=script&lang=js"

import "./Policies.vue?vue&type=style&index=0&id=49bdde53&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49bdde53"]])

export default __exports__